// Royal Keys product card — video preview on hover
(function () {
  function initCardVideos(root) {
    root.querySelectorAll('.rk-card').forEach(function (card) {
      var video = card.querySelector('.rk-card__preview-video');
      if (!video) return;

      card.addEventListener('mouseenter', function () {
        // Swap data-src → src on first hover so the video loads lazily
        video.querySelectorAll('source').forEach(function (source) {
          if (source.dataset.src && source.src !== source.dataset.src) {
            source.src = source.dataset.src;
          }
        });
        if (video.readyState === 0) video.load();
        video.play().then(function () {
          card.classList.add('is-playing');
        }).catch(function () {});
      });

      card.addEventListener('mouseleave', function () {
        video.pause();
        video.currentTime = 0;
        card.classList.remove('is-playing');
      });
    });
  }

  // Initial page load
  document.addEventListener('DOMContentLoaded', function () {
    initCardVideos(document);
  });

  // Re-init after load-more / infinite scroll injects new cards
  document.addEventListener('page:loaded', function () {
    initCardVideos(document);
  });
})();
